import React, { createContext, useContext, useState } from "react";

const PageLoadContext = createContext();

export const PageLoadProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);

    return (
        <PageLoadContext.Provider value={{ loading, setLoading }}>
            {children}
        </PageLoadContext.Provider>
    );
};

export const usePageLoad = () => useContext(PageLoadContext);
